export default "__VITE_ASSET__BDqmrV81__"